import Lazyimg from '@components/utils/Lazyimg';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import React, { useMemo } from 'react';
const Image = (props) => {
    const { isMobile } = useMediaQueries();
    const args = useMemo(() => {
        return {
            src: isMobile && props.srcMobile ? props.srcMobile : props.src,
            alt: props.alt || '',
            className: props.className,
        };
    }, [props, isMobile]);
    return props.avoidLazy ? React.createElement("img", Object.assign({ alt: args.alt }, args, { "aria-hidden": props.ariaHidden })) : React.createElement(Lazyimg, Object.assign({}, args, { ariaHidden: props.ariaHidden }));
};
export default Image;
